import CommonAction from '../../shared/Http/Http';
import {BID_BY_COUNTRY_GET, BID_BY_COUNTRY_EDIT} from '../constants';

export const getBids = (globalType,provider) => CommonAction('GET', null, `backoffice-extended/settings/get/?globalType=${globalType}&provider=${provider}`, BID_BY_COUNTRY_GET, null);
export const editBid = (body) => CommonAction('PUT', null, `backoffice-extended/settings/edit`, BID_BY_COUNTRY_EDIT, body);